.calendar {
  font-family: "Poppins";
  background-color: white;
}

.calendarDark {
  /*  */
  font-family: "Poppins";
  background-color: #a3a3a3;
}

.dayText {
  font-family: "Poppins";
}
